import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import checkView from 'vue-check-view';
import 'vuetify/dist/vuetify.min.css';
Vue.use(checkView)

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
          options: {
            customProperties: true,
          },
          light: {
            primary: '#D32F2F',
            secondary: '#A3C4BC',
            accent: '#4A6D7C',
            error: '#b71c1c',
          },
        },
      },
});